import Markdown from 'react-markdown';

type SiteBannerMarkdownContentProps = {
  message: string;
};

export const SiteBannerMarkdownContent: React.FC<
  SiteBannerMarkdownContentProps
> = ({ message }) => (
  <Markdown className="[&>ul>li::marker]:text-inherit [&>ul>li]:marker:text-inherit [&>ul]:list-disc [&_a]:underline">
    {message}
  </Markdown>
);
